import React, { Component } from 'react';
import ProductsList from '../Components/ProductsList';
import Sliders from './Slider.Container';

export const ProductStep = ({products, handleSelectproduct, steps, selectedProducts}) => {
    let productProps ={
        products,
        selectedProducts,
        handleSelectproduct
    }
    return (
        <div className={`steps${steps.currentStep === 1 ? ' active' : ''}`}>
            <Sliders />
            <ProductsList {...productProps}/>
        </div>
    )
}